import * as React from "react";
const ProfileView = React.lazy(() => import("./ProfileViewContainer"));

export { ProfileView };
